import saveUpdateClient from './saveUpdateClient'

export const saveUpdateClientPromise = saveUpdateClient
